import React from 'react';
import styles from './ModalStyles.module.scss';
import { FileDropzone } from '../../../../components/uikit/FileDropzone.tsx';
import { AdvancedFormReturnType } from '../../../../helpers/form/useAdvancedForm.ts';
import { Form } from './AddDeviceModal.tsx';
import { useWatch } from 'react-hook-form';
import { useScopedTranslation } from '../../../../application/localization/useScopedTranslation.ts';

type OwnProps = {
  form: AdvancedFormReturnType<Form>;
};

const maxFileSize = 1024 * 1024; // 1 MB

export const ReceiptScreen = (props: OwnProps) => {
  const { form } = props;

  const i18n = useScopedTranslation('Page.CreateRepairRequest');

  const handleFileSelected = (file: File | null) => {
    form.clearErrors('receiptFile');
    form.setOverallError('');
    form.setValue('receiptFile', file, {
      shouldValidate: true,
      shouldDirty: true,
    });
    form.setValue('receiptFileName', file?.name ?? null, {
      shouldDirty: true,
    });
    form.setValue('receiptFileId', null, {
      shouldDirty: true,
    });
  };

  const [receiptFile, receiptFileName] = useWatch({
    control: form.control,
    name: ['receiptFile', 'receiptFileName'],
  });

  return (
    <div>
      <div className={styles.receiptDescription}>
        {i18n.t('modal_receipt_desc')}
      </div>
      <div className={styles.containerItem}>
        <div
          className={styles.dropZone}
          data-test-id="mainboard-request-file-container"
        >
          <FileDropzone
            onFileSelected={handleFileSelected}
            supportedFileTypes={['.png', '.jpeg', '.pdf']}
            selectedFileProps={receiptFile}
            selectedFileName={receiptFileName}
            errorText={form.formState.errors.receiptFile?.message}
            maxFileSize={maxFileSize}
            hideAttachFileText={true}
          />
        </div>
      </div>
    </div>
  );
};
